import { KvpsDealerIdSchema, type KvpsDealerId } from '@org-avp/models';
import { z } from 'zod';

// Same rule as `@org-avp/device-models`; importing that package would bundle its older `@org-avp/models` copy into the main entry.
const UUID_V4_PATTERN = /^[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-4[0-9A-Fa-f]{3}-[89ABab][0-9A-Fa-f]{3}-[0-9A-Fa-f]{12}$/;

/** True for a local AVE device id of the form `<KVPS dealer id>_<UUID v4>`. */
export function isThingName(name: string): boolean {
  const [dealerId, uuid] = name.split('_', 2);
  return KvpsDealerIdSchema.safeParse(dealerId).success && Boolean(uuid) && UUID_V4_PATTERN.test(uuid);
}

export const ThingNameSchema = z
  .string()
  .refine(isThingName, { error: (issue) => `Invalid ThingName: "${String(issue.input)}"` })
  .brand<'ThingName'>();

export type ThingName = z.infer<typeof ThingNameSchema>;

/** The KVPS dealer id a thingName starts with (brand letter included). */
export function getKvpsDealerId(thingName: ThingName): KvpsDealerId {
  return KvpsDealerIdSchema.parse(thingName.substring(0, 9));
}
